import { composeModule } from '@opengov/compose-app';

import pkg from '../package.json';

export const {
  composeStateMachine,
  composeEffects,
  composeMiddleware,
  composeSubscriber,
  exportModule
} = composeModule(pkg.name, pkg.version);
